module.exports = __webpack_public_path__ + "img/empty-search-2.7df1c16f.svg";